//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moduleName from '~/static/moduleName.json';
import roomId from '~/static/roomId.json';
import languages from '~/static/languages.json';
import seatTotal from '~/static/seatTotal.json';

export default {
  name: "editMsModalPanel",
  data: function data() {
    return {
      moduleInfo: {
        // new module session info
        moduleName: null,
        roomId: 1,
        sessionTimeRaw: null,
        seatTotal: 30,
        // seatTaken: !!this.$store.state.currentModuleSession? this.$store.state.currentModuleSession.seatTaken : 0,
        trainerName: '',
        language: null
      },
      moduleName: moduleName,
      roomId: roomId,
      seatTotal: seatTotal,
      languages: languages
    };
  },

  methods: {
    updateModuleSessionInfo: function updateModuleSessionInfo() {
      if (!!this.moduleInfo.moduleName && !!this.moduleInfo.roomId && !!this.moduleInfo.sessionTimeRaw && !!this.moduleInfo.seatTotal && !!this.moduleInfo.trainerName && !!this.moduleInfo.language) {
        this.$emit('updateModuleSessionInfo', this.moduleInfo);
        this.resetAll();
      } else {
        alert('Please Fill Up All Blank Fields');
      }
    },
    resetAll: function resetAll() {
      this.moduleInfo = {
        moduleName: null,
        roomId: null,
        sessionTimeRaw: null,
        seatTotal: 30,
        // seatTaken: 0,
        trainerName: '',
        language: null
      };
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/mainPage/EditMsModalPanel.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/mainPage/EditMsModalPanel.vue
// module chunks = 6